<template>
  <b-dropdown
    :boundary="boundary"
    class="dropdown-default"
    :dropup="isDropUp"
    :menu-class="calcMenuClass"
    :disabled="disabled"
    :block="block"
    :popper-opts="popperOpts">
    <template #button-content>
      <slot :selected-item="selectedItem" :selected-text="selectedDisplayText">
        <span class="ellipsis" v-if="showTooltip" v-tooltip.ellipsis="selectedDisplayText || props.default">
          {{ selectedDisplayText || props.default }}
        </span>
        <span v-else class="ellipsis">
          {{ selectedDisplayText || props.default }}
        </span>
      </slot>
    </template>
    <EmptyState is-insde-element v-if="!items.length"> {{ emptyStateText }}</EmptyState>
    <b-dropdown-item
      v-for="item in localItems"
      :key="item[props.valueField]"
      :data-cy="item[valueField]"
      @click="selectItem(item)"
      :active="active === true ? true : item[props.valueField] === selectedItem?.[valueField]">
      <slot :entry="item" name="item-template">{{ item ? item[props.textField] : "" }}</slot>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script setup lang="ts" generic="T">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import EmptyState from "./EmptyState.vue";

const { t: $t } = useI18n();
const emit = defineEmits(["input", "change"]);

const props = defineProps<{
  value?: string | number | null;
  menuClass?: string;
  items: T[];
  textField: keyof T;
  valueField: keyof T;
  displayField?: keyof T;
  boundary?: string;
  block?: boolean;
  disabled?: boolean;
  active?: boolean;
  default?: string;
  showTooltip?: boolean;
  popperOpts?: Record<string, any>;
  isDropUp?: boolean;
  emptyState?: string;
}>();

const localItems = computed(() => {
  return props.items || [];
});

const itemMap = computed(() => {
  const map: Map<any, any> = new Map();
  for (const item of localItems.value) {
    map.set(item[props.valueField], item);
  }
  return map;
});

const selectedItem = computed(() => (props.value !== undefined && itemMap.value.has(props.value) ? itemMap.value.get(props.value) : null));

const selectedDisplayText = computed(() => {
  return selectedItem.value?.[props.displayField || props.textField];
});

const calcMenuClass = computed(() => {
  return [props.boundary, props.menuClass].filter((x) => x);
});

const emptyStateText = computed(() => {
  return props.emptyState ? props.emptyState : $t("dropdown.emptyState.default");
});

function selectItem(item: T) {
  emit("input", item[props.valueField]);
  emit("change", item[props.valueField]);
}
</script>
